module.exports = __webpack_public_path__ + "static/media/front-cover.6af9ff14.png";